/**
 * TrendModa - Üst Bar Mesaj Rotasyonu
 */
(function () {
  'use strict';

  function init() {
    var messages = document.querySelectorAll('.topbar__msg');
    if (messages.length < 2) return;

    var current = 0;
    messages[0].classList.add('topbar__msg--active');

    setInterval(function () {
      messages[current].classList.remove('topbar__msg--active');
      current = (current + 1) % messages.length;
      messages[current].classList.add('topbar__msg--active');
    }, 3500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
